import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Rent.css";

function Rent() {

  const [rentData, setRentData] = useState([]);
  const [imageIndex, setImageIndex] = useState({});
  const navigate = useNavigate();

  useEffect(() => {

  fetch("https://urbanbrick.in.net/get-properties.php")
    .then(res => res.json())
    .then(data => {

      const rentFiltered = data.filter(
        (item) => item.listingType === "Rent"
      );

      setRentData(rentFiltered);

    })
    .catch(err => console.log(err));

}, []);

  const nextImage = (id, total) => {

    setImageIndex((prev) => ({

      ...prev,

      [id]:
        (prev[id] + 1) % total || 0

    }));

  };

  const prevImage = (id, total) => {

    setImageIndex((prev) => ({

      ...prev,

      [id]:
        prev[id] === 0
          ? total - 1
          : prev[id] - 1

    }));

  };

  return (

    <div className="rent-page">

      <h2 className="rent-title">
        Rent Properties
      </h2>

      <div className="rent-grid">

        {rentData.length === 0 ? (

          <p className="rent-empty">
            No Rent Properties Available
          </p>

        ) : (

          rentData.map((item) => {

            const current =
              imageIndex[item.id] || 0;

            return (

              <div
                className="rent-card"
                key={item.id}
              >

                <div className="rent-image-box">

                  <button
                    className="rent-arrow left"
                    onClick={() =>
                      prevImage(
                        item.id,
                        item.images.length
                      )
                    }
                  >
                    ❮
                  </button>

                  <img
                    src={
                      item.images?.[
                        current
                      ]
                    }
                    alt=""
                    className="rent-image"
                  />

                  <button
                    className="rent-arrow right"
                    onClick={() =>
                      nextImage(
                        item.id,
                        item.images.length
                      )
                    }
                  >
                    ❯
                  </button>

                </div>

                <div className="rent-info">

                  <h3>
                    {item.title}
                  </h3>

                  <p>
                    {item.property_type}
                  </p>

                  <p>
                    📍 {item.city}
                  </p>

                  <p>
                    ₹ {item.price}
                  </p>

                  <button
                    className="rent-button"
                    onClick={() =>
                      navigate(`/property/${item.id}`)
                    }
                  >
                    View Details
                  </button>

                </div>

              </div>

            );

          })

        )}

      </div>

    </div>

  );

}

export default Rent;